
import vSelect from "vue-select"
import { Ref, Prop, Component, Vue } from "vue-property-decorator"
import { Template, CaseDetails, CaseField } from "@/types"
import { BModal } from "bootstrap-vue"
import { Getter, namespace } from "vuex-class"
import { TenantFeatures } from "@/types/tenantFeatures"
import { TriageTemplateChangeSetting } from "@/types/triage"
import { TenantSettingKeys } from "@/types/tenantSetting"
import api from "@/services/api"

const caseStore = namespace("cases")

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class TemplateSelect extends Vue {
	@Ref()
	public templateSelect!: { _data: { _value: Template | null } }

	@Ref()
	public triageConfirmationModal!: BModal

	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	@Getter getTenantSettings!: { [key: string]: any } | null

	@Getter("getCaseName") caseName!: string;

	@caseStore.Getter("getCreatableCategories") public categories!: Template[] | null;

	@Prop({ required: true })
	public currentCase!: CaseDetails

	TriageTemplateChangeSetting = TriageTemplateChangeSetting

	// For Triage confirmation dialog
	fieldsToDiscard: CaseField[] = []
	oldTemplate: Template | null = null
	newTemplate: Template | null = null

	templateChanged (templateId: string) {
		this.$emit("templateChanged", templateId)
	}

	get newCase () {
		return !(this.currentCase.id)
	}

	get tenantTriageTemplateChangeSetting (): TriageTemplateChangeSetting {
		const tenantSettings = this.getTenantSettings ?? {}
		const triageChangeSetting = tenantSettings[TenantSettingKeys.TriageTemplateChange]
		if (triageChangeSetting) {
			return triageChangeSetting
		} else {
			return TriageTemplateChangeSetting.Disallow
		}
	}

	get casePendingTriage (): boolean {
		return !!this.currentCase && !!this.currentCase.pendingTriage && !this.currentCase.closed &&
			this.getIsFeatureEnabled(TenantFeatures.Triage) &&
			this.tenantTriageTemplateChangeSetting !== TriageTemplateChangeSetting.Disallow
	}

	async triageCaseTemplateChanging (templateId: string) {
		const newTemplate = await api.templateDetails(templateId)
		const currentTemplate = this.currentCase?.templateId
			? await api.templateDetails(this.currentCase.templateId)
			: null

		if (!currentTemplate) {
			return
		}

		let fieldsToDiscard: CaseField[] = []

		if (this.tenantTriageTemplateChangeSetting !== TriageTemplateChangeSetting.Keep) {
			fieldsToDiscard =
				Object.values(this.currentCase.fields)?.filter(f =>
					!!f?.field && !newTemplate.fields?.some(nf => !!nf.field && nf.field.id === f.field.id)
				) ?? []
		}

		this.fieldsToDiscard = fieldsToDiscard
		this.oldTemplate = currentTemplate
		this.newTemplate = newTemplate

		this.triageConfirmationModal.show()
	}

	cancelTriageTemplateChange () {
		// set the select's internal value back to the old value
		this.templateSelect._data._value = this.oldTemplate ?? null
	}

	async acceptTriageTemplateChange (keepFields: boolean = true) {
		await api.setCaseTemplate(this.currentCase.id!, this.newTemplate!.id!, keepFields)
	}
}
